import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from './modules/user';
import dict from './modules/dict';
import Cookies from "js-cookie";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        // 状态
        avatarUrl:avatarUrl(), //用户头像
        
    },
    mutations: {
        // 改变方法
        setAvatarPath(state,path){
            state.avatarUrl = path;
        }
    },
    actions: {

    },
    modules: {
        app,
        user,
        dict
    }
});

function avatarUrl() {
    let url ='';
    if(Cookies.get("userInfo") && JSON.parse(Cookies.get("userInfo")).photo!=''){
        url = JSON.parse(Cookies.get("userInfo")).photo;
    }
    return url
}

export default store;
